import React from "react";
import PropTypes from "prop-types";
import { MenuItem } from "react-contextmenu";
import { Icon } from "rhombus-react";
import { noop } from "utils/common";

export default function BasicAction({
	iconName,
	name,
	className,
	isDisabled,
	handleClick,
	iconClass,
	tooltipContent,
}){
	/*
		`react-contextmenu` gets mad if you don't use a `MenuItem` and try to just render
		other stuff with its own click handlers.

		It captures the click and the child content never sees the event.
	*/
	return (
		<MenuItem disabled={isDisabled} className={`action-item ${className}`} onClick={handleClick} >
			<a data-tip={tooltipContent}> {/* This `a` tag doesn't serve a semantic purpose here, but if it's missing, it dodges a Rhombus style that adds padding. */}
				<span className={`action-icon ${className}`}>
					<Icon name={iconName} className={iconClass} />
				</span>
				<span className="action-name">
					{name}
				</span>
			</a>
		</MenuItem>
	);
}

BasicAction.displayName = "BasicAction";
BasicAction.defaultProps = {
	isDisabled:		false,
	handleClick:	noop,
	className:		"",
	iconName:		"",
	iconClass:		"",
	tooltipContent:	"",
};
BasicAction.propTypes ={
	iconName:		PropTypes.string.isRequired,
	name: 			PropTypes.string,
	iconClass: 		PropTypes.string,
	className:		PropTypes.string,
	tooltipContent:	PropTypes.string,
	isDisabled:		PropTypes.bool,
	handleClick:	PropTypes.func,
};
